export default "__VITE_ASSET__BNkRn3Sy__"